import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, AlertTriangleIcon, BrainIcon, UsersIcon, MapPinIcon, GlobeIcon, CheckIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { Badge } from '../components/ui/Badge';
function AppMockup() {
  return <div className="relative w-full max-w-2xl mx-auto" data-id="element-583">
      <div className="rotate-1 rounded-2xl overflow-hidden shadow-2xl border border-parchment bg-white" data-id="element-584">
        {/* App Header */}
        <div className="bg-navy px-4 py-3 flex items-center gap-3" data-id="element-585">
          <div className="flex gap-1.5" data-id="element-586">
            <span className="w-3 h-3 rounded-full bg-red-400/60" data-id="element-587"></span>
            <span className="w-3 h-3 rounded-full bg-yellow-400/60" data-id="element-588"></span>
            <span className="w-3 h-3 rounded-full bg-green-400/60" data-id="element-589"></span>
          </div>
          <div className="flex-1 bg-white/10 rounded-md px-3 py-1" data-id="element-590">
            <span className="font-sans text-xs text-white/50" data-id="element-591">
              slateandpage.app / project / the-long-road
            </span>
          </div>
        </div>

        <div className="flex h-80" data-id="element-592">
          {/* Sidebar */}
          <div className="w-48 bg-navy/95 flex-shrink-0 p-4 flex flex-col gap-1" data-id="element-593">
            <div className="font-sans text-xs text-white/40 uppercase tracking-widest mb-3 px-2" data-id="element-594">
              The Long Road
            </div>
            <button className="flex items-center gap-2 px-2 py-2 rounded-lg bg-amber/20 text-amber text-xs font-sans font-medium" data-id="element-595">
              <UsersIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-596" />
              Characters
            </button>
            <button className="flex items-center gap-2 px-2 py-2 rounded-lg text-white/50 text-xs font-sans hover:text-white/80 transition-colors" data-id="element-597">
              <MapPinIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-598" />
              Locations
            </button>
            <button className="flex items-center gap-2 px-2 py-2 rounded-lg text-white/50 text-xs font-sans hover:text-white/80 transition-colors" data-id="element-599">
              <BookOpenIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-600" />
              Scenes
            </button>
            <button className="flex items-center gap-2 px-2 py-2 rounded-lg text-white/50 text-xs font-sans hover:text-white/80 transition-colors" data-id="element-601">
              <GlobeIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-602" />
              World
            </button>
            <div className="mt-auto" data-id="element-603">
              <div className="w-full h-px bg-white/10 mb-3" data-id="element-604"></div>
              <div className="flex items-center gap-2 px-2" data-id="element-605">
                <div className="w-6 h-6 rounded-full bg-amber/30 flex items-center justify-center" data-id="element-606">
                  <span className="text-amber text-xs font-serif font-bold" data-id="element-607">
                    E
                  </span>
                </div>
                <span className="font-sans text-xs text-white/50" data-id="element-608">
                  Elena Marsh
                </span>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 bg-cream p-5 overflow-hidden" data-id="element-609">
            <div className="flex items-start justify-between mb-4" data-id="element-610">
              <div data-id="element-611">
                <h3 className="font-serif font-semibold text-ink text-base" data-id="element-612">
                  Elena Marsh
                </h3>
                <p className="font-sans text-xs text-ink-light mt-0.5" data-id="element-613">
                  Protagonist · Feature Film
                </p>
              </div>
              <span className="bg-amber-light text-warm-brown text-xs font-sans font-medium px-2 py-0.5 rounded-full border border-amber/20" data-id="element-614">
                Arc: Redemption
              </span>
            </div>

            <div className="space-y-3" data-id="element-615">
              <div className="bg-white rounded-lg p-3 border border-parchment" data-id="element-616">
                <div className="font-sans text-xs text-ink-light uppercase tracking-wide mb-1.5" data-id="element-617">
                  Core Goal
                </div>
                <p className="font-sans text-xs text-ink-muted leading-relaxed" data-id="element-618">
                  Reconcile with her estranged daughter before it's too late
                </p>
              </div>
              <div className="bg-white rounded-lg p-3 border border-parchment" data-id="element-619">
                <div className="font-sans text-xs text-ink-light uppercase tracking-wide mb-1.5" data-id="element-620">
                  Fatal Flaw
                </div>
                <p className="font-sans text-xs text-ink-muted leading-relaxed" data-id="element-621">
                  Prioritizes work over relationships; avoids vulnerability
                </p>
              </div>
              <div className="bg-white rounded-lg p-3 border border-parchment" data-id="element-622">
                <div className="font-sans text-xs text-ink-light uppercase tracking-wide mb-2" data-id="element-623">
                  Scene Appearances
                </div>
                <div className="flex flex-wrap gap-1" data-id="element-624">
                  <span className="bg-navy/10 text-navy text-xs font-sans px-2 py-0.5 rounded-full" data-id="element-625">
                    Sc. 1
                  </span>
                  <span className="bg-navy/10 text-navy text-xs font-sans px-2 py-0.5 rounded-full" data-id="element-626">
                    Sc. 3
                  </span>
                  <span className="bg-amber-light text-warm-brown text-xs font-sans px-2 py-0.5 rounded-full border border-amber/20" data-id="element-627">
                    Sc. 12 ★
                  </span>
                  <span className="bg-navy/10 text-navy text-xs font-sans px-2 py-0.5 rounded-full" data-id="element-628">
                    Sc. 18
                  </span>
                  <span className="bg-navy/10 text-navy text-xs font-sans px-2 py-0.5 rounded-full" data-id="element-629">
                    Sc. 22
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating accent cards */}
      <div className="absolute -bottom-4 -left-6 bg-white rounded-xl shadow-lg border border-parchment p-3 hidden lg:flex items-center gap-2.5 -rotate-2" data-id="element-630">
        <div className="w-8 h-8 bg-amber-light rounded-lg flex items-center justify-center" data-id="element-631">
          <CheckIcon className="w-4 h-4 text-warm-brown" aria-hidden="true" data-id="element-632" />
        </div>
        <div data-id="element-633">
          <div className="font-sans text-xs font-semibold text-ink" data-id="element-634">
            Continuity check
          </div>
          <div className="font-sans text-xs text-ink-light" data-id="element-635">
            Scar present in Sc. 12 ✓
          </div>
        </div>
      </div>

      <div className="absolute -top-4 -right-4 bg-navy rounded-xl shadow-lg p-3 hidden lg:block rotate-2" data-id="element-636">
        <div className="font-sans text-xs text-white/60 mb-1" data-id="element-637">
          World elements linked
        </div>
        <div className="font-sans text-lg font-semibold text-amber" data-id="element-638">247</div>
      </div>
    </div>;
}
export function HomePage() {
  return <main className="w-full" data-id="element-639">
      {/* Section A: Hero */}
      <section className="min-h-screen bg-cream flex flex-col justify-center pt-24 pb-16 px-6 lg:px-8" aria-labelledby="hero-heading" data-id="element-640">
        <div className="max-w-7xl mx-auto w-full" data-id="element-641">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-642">
            {/* Left: Text */}
            <div className="max-w-xl" data-id="element-643">
              <div className="mb-6" data-id="element-644">
                <Badge variant="amber" data-id="element-645">
                  <SparklesIcon className="w-3 h-3" aria-hidden="true" data-id="element-646" />
                  Early Access — Beta
                </Badge>
              </div>

              <h1 id="hero-heading" className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-ink leading-[1.1] tracking-tight mb-6" data-id="element-647">
                Your story's
                <br data-id="element-648" />
                <em className="text-amber" style={{
                fontStyle: 'italic'
              }} data-id="element-649">
                  second brain.
                </em>
              </h1>

              <p className="font-sans text-lg md:text-xl text-ink-muted leading-relaxed mb-8 max-w-lg" data-id="element-650">
                Slate & Page is the development layer between you and your
                screenplay — where characters, scenes, locations, and
                world-building live together, connected and searchable.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-651">
                <Link to="/waitlist" className="font-sans font-medium text-base bg-amber hover:bg-amber-dark text-white px-8 py-4 rounded-full transition-colors shadow-md text-center" data-id="element-652">
                  Join the Waitlist
                </Link>
                <Link to="/features" className="font-sans font-medium text-base text-ink-muted hover:text-ink px-8 py-4 rounded-full border border-parchment hover:border-ink-light transition-colors text-center flex items-center justify-center gap-2" data-id="element-653">
                  See how it works
                  <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-654" />
                </Link>
              </div>

              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 font-sans text-xs text-ink-light" data-id="element-655">
                <span className="flex items-center gap-1.5" data-id="element-656">
                  <span className="text-amber" data-id="element-657">✦</span>
                  Free forever plan
                </span>
                <span className="flex items-center gap-1.5" data-id="element-658">
                  <span className="text-amber" data-id="element-659">✦</span>
                  No credit card required
                </span>
                <span className="flex items-center gap-1.5" data-id="element-660">
                  <span className="text-amber" data-id="element-661">✦</span>
                  Early Access
                </span>
              </div>
            </div>

            {/* Right: App Mockup */}
            <div className="hidden lg:block" data-id="element-662">
              <AppMockup data-id="element-663" />
            </div>
          </div>
        </div>
      </section>

      {/* Section B: The Problem */}
      <section className="bg-parchment py-24 px-6 lg:px-8" aria-labelledby="problem-heading" data-id="element-664">
        <div className="max-w-7xl mx-auto" data-id="element-665">
          <div className="max-w-2xl mb-16" data-id="element-666">
            <h2 id="problem-heading" className="font-serif text-3xl md:text-4xl font-bold text-ink mb-6 leading-tight" data-id="element-667">
              Your story lives in seventeen different places.
            </h2>
            <p className="font-sans text-base md:text-lg text-ink-muted leading-relaxed" data-id="element-668">
              Character notes in a Google Doc. Location details in a
              spreadsheet. Scene ideas in a notebook. Continuity questions in
              your head at 2am. Sound familiar?
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-669">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-parchment hover:shadow-md transition-shadow" data-id="element-670">
              <div className="w-12 h-12 bg-amber-light rounded-xl flex items-center justify-center mb-5" data-id="element-671">
                <BookOpenIcon className="w-6 h-6 text-warm-brown" aria-hidden="true" data-id="element-672" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-ink mb-3" data-id="element-673">
                Scattered across tools
              </h3>
              <p className="font-sans text-sm text-ink-muted leading-relaxed" data-id="element-674">
                Notes, docs, spreadsheets, and sticky notes that never talk to
                each other.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-sm border border-parchment hover:shadow-md transition-shadow" data-id="element-675">
              <div className="w-12 h-12 bg-amber-light rounded-xl flex items-center justify-center mb-5" data-id="element-676">
                <AlertTriangleIcon className="w-6 h-6 text-warm-brown" aria-hidden="true" data-id="element-677" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-ink mb-3" data-id="element-678">
                Continuity gaps
              </h3>
              <p className="font-sans text-sm text-ink-muted leading-relaxed" data-id="element-679">
                "Did she have the scar in Scene 12?" The details that slip
                through the cracks and cost you rewrites.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-sm border border-parchment hover:shadow-md transition-shadow" data-id="element-680">
              <div className="w-12 h-12 bg-amber-light rounded-xl flex items-center justify-center mb-5" data-id="element-681">
                <BrainIcon className="w-6 h-6 text-warm-brown" aria-hidden="true" data-id="element-682" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-ink mb-3" data-id="element-683">
                Mental overload
              </h3>
              <p className="font-sans text-sm text-ink-muted leading-relaxed" data-id="element-684">
                Creative energy spent on logistics instead of storytelling. Your
                brain is for ideas, not inventory.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section C: Feature Highlights */}
      <section className="bg-cream py-24 px-6 lg:px-8" aria-labelledby="features-heading" data-id="element-685">
        <div className="max-w-7xl mx-auto" data-id="element-686">
          <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-687">
            <h2 id="features-heading" className="font-serif text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-688">
              Everything your story needs. One place.
            </h2>
            <p className="font-sans text-base text-ink-muted leading-relaxed" data-id="element-689">
              Slate & Page connects every element of your story — so you can see
              the full picture and focus on what matters: the writing.
            </p>
          </div>

          {/* Feature 1: Characters — text left, mockup right */}
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-690">
            <div data-id="element-691">
              <Badge variant="amber" className="mb-5" data-id="element-692">
                Character Development
              </Badge>
              <h3 className="font-serif text-3xl font-bold text-ink mb-4 leading-tight" data-id="element-693">
                Track every arc, from first scene to last.
              </h3>
              <p className="font-sans text-base text-ink-muted leading-relaxed mb-6" data-id="element-694">
                Rich character profiles that go beyond the basics. Goals, flaws,
                coping styles, speech patterns, formative events — and every
                scene they appear in, mapped to their emotional arc.
              </p>
              <ul className="space-y-3 mb-8" role="list" data-id="element-695">
                <li className="flex items-start gap-3" data-id="element-696">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-697" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-698">
                    Emotional arc tracking across scenes
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-699">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-700" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-701">
                    Relationship mapping and dynamics
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-702">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-703" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-704">
                    Turning points and character beats
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-705">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-706" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-707">
                    Speech patterns and voice notes
                  </span>
                </li>
              </ul>
              <Link to="/features" className="font-sans text-sm font-medium text-amber hover:text-amber-dark flex items-center gap-2 transition-colors" data-id="element-708">
                Explore character tools
                <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-709" />
              </Link>
            </div>
            <div className="bg-parchment rounded-2xl p-8 border border-parchment/80" data-id="element-710">
              <div className="bg-white rounded-xl shadow-sm border border-parchment overflow-hidden" data-id="element-711">
                <div className="bg-navy px-4 py-3" data-id="element-712">
                  <span className="font-sans text-xs text-white/50" data-id="element-713">
                    Characters · The Long Road
                  </span>
                </div>
                <div className="p-5 space-y-3" data-id="element-714">
                  <div className="flex items-center justify-between p-3 bg-cream rounded-lg border border-parchment" data-id="element-715">
                    <div className="flex items-center gap-3" data-id="element-716">
                      <div className="w-8 h-8 rounded-full bg-amber/20 flex items-center justify-center" data-id="element-717">
                        <span className="font-serif text-sm font-bold text-amber" data-id="element-718">
                          E
                        </span>
                      </div>
                      <div data-id="element-719">
                        <div className="font-sans text-sm font-medium text-ink" data-id="element-720">
                          Elena Marsh
                        </div>
                        <div className="font-sans text-xs text-ink-light" data-id="element-721">
                          Protagonist · Redemption arc
                        </div>
                      </div>
                    </div>
                    <span className="font-sans text-xs bg-amber-light text-warm-brown px-2 py-0.5 rounded-full border border-amber/20" data-id="element-722">
                      22 scenes
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-cream rounded-lg border border-parchment" data-id="element-723">
                    <div className="flex items-center gap-3" data-id="element-724">
                      <div className="w-8 h-8 rounded-full bg-navy/20 flex items-center justify-center" data-id="element-725">
                        <span className="font-serif text-sm font-bold text-navy" data-id="element-726">
                          D
                        </span>
                      </div>
                      <div data-id="element-727">
                        <div className="font-sans text-sm font-medium text-ink" data-id="element-728">
                          David Okafor
                        </div>
                        <div className="font-sans text-xs text-ink-light" data-id="element-729">
                          Antagonist · Power arc
                        </div>
                      </div>
                    </div>
                    <span className="font-sans text-xs bg-navy/10 text-navy px-2 py-0.5 rounded-full" data-id="element-730">
                      14 scenes
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-cream rounded-lg border border-parchment" data-id="element-731">
                    <div className="flex items-center gap-3" data-id="element-732">
                      <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center" data-id="element-733">
                        <span className="font-serif text-sm font-bold text-green-700" data-id="element-734">
                          M
                        </span>
                      </div>
                      <div data-id="element-735">
                        <div className="font-sans text-sm font-medium text-ink" data-id="element-736">
                          Maya Chen
                        </div>
                        <div className="font-sans text-xs text-ink-light" data-id="element-737">
                          Supporting · Catalyst
                        </div>
                      </div>
                    </div>
                    <span className="font-sans text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full" data-id="element-738">
                      9 scenes
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Feature 2: Locations — mockup left, text right */}
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-739">
            <div className="bg-navy rounded-2xl p-8 order-2 lg:order-1" data-id="element-740">
              <div className="bg-white/10 rounded-xl overflow-hidden border border-white/10" data-id="element-741">
                <div className="px-4 py-3 border-b border-white/10" data-id="element-742">
                  <span className="font-sans text-xs text-white/50" data-id="element-743">
                    Location · The Marsh House
                  </span>
                </div>
                <div className="p-5 space-y-4" data-id="element-744">
                  <div data-id="element-745">
                    <div className="font-sans text-xs text-white/40 uppercase tracking-wide mb-2" data-id="element-746">
                      Atmosphere
                    </div>
                    <div className="flex flex-wrap gap-2" data-id="element-747">
                      <span className="bg-amber/20 text-amber text-xs font-sans px-2.5 py-1 rounded-full" data-id="element-748">
                        Isolated
                      </span>
                      <span className="bg-amber/20 text-amber text-xs font-sans px-2.5 py-1 rounded-full" data-id="element-749">
                        Decaying
                      </span>
                      <span className="bg-amber/20 text-amber text-xs font-sans px-2.5 py-1 rounded-full" data-id="element-750">
                        Nostalgic
                      </span>
                    </div>
                  </div>
                  <div data-id="element-751">
                    <div className="font-sans text-xs text-white/40 uppercase tracking-wide mb-2" data-id="element-752">
                      Color Palette
                    </div>
                    <div className="flex gap-2" data-id="element-753">
                      <div className="w-8 h-8 rounded-lg bg-amber/60 border border-white/10" data-id="element-754"></div>
                      <div className="w-8 h-8 rounded-lg bg-slate-600 border border-white/10" data-id="element-755"></div>
                      <div className="w-8 h-8 rounded-lg bg-stone-400 border border-white/10" data-id="element-756"></div>
                      <div className="w-8 h-8 rounded-lg bg-green-900 border border-white/10" data-id="element-757"></div>
                    </div>
                  </div>
                  <div data-id="element-758">
                    <div className="font-sans text-xs text-white/40 uppercase tracking-wide mb-2" data-id="element-759">
                      Transformation Arc
                    </div>
                    <p className="font-sans text-xs text-white/70 leading-relaxed" data-id="element-760">
                      Begins as a place of dread → becomes a site of
                      reconciliation by Act III
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2" data-id="element-761">
              <Badge variant="amber" className="mb-5" data-id="element-762">
                Location Management
              </Badge>
              <h3 className="font-serif text-3xl font-bold text-ink mb-4 leading-tight" data-id="element-763">
                Locations as narrative elements, not just settings.
              </h3>
              <p className="font-sans text-base text-ink-muted leading-relaxed mb-6" data-id="element-764">
                Every space in your story has mood, atmosphere, and meaning.
                Track how your locations transform from the first scene to the
                last — and how they shape the characters who inhabit them.
              </p>
              <ul className="space-y-3 mb-8" role="list" data-id="element-765">
                <li className="flex items-start gap-3" data-id="element-766">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-767" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-768">
                    Mood, atmosphere, and lighting notes
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-769">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-770" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-771">
                    Color palette and visual identity
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-772">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-773" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-774">
                    Spatial relationships and geography
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-775">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-776" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-777">
                    Transformation arc from Act I to III
                  </span>
                </li>
              </ul>
              <Link to="/features" className="font-sans text-sm font-medium text-amber hover:text-amber-dark flex items-center gap-2 transition-colors" data-id="element-778">
                Explore location tools
                <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-779" />
              </Link>
            </div>
          </div>

          {/* Feature 3: World-building — text left, mockup right */}
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-780">
            <div data-id="element-781">
              <Badge variant="amber" className="mb-5" data-id="element-782">
                World-Building
              </Badge>
              <h3 className="font-serif text-3xl font-bold text-ink mb-4 leading-tight" data-id="element-783">
                Build the world your story lives in.
              </h3>
              <p className="font-sans text-base text-ink-muted leading-relaxed mb-6" data-id="element-784">
                From magic systems to invented slang, from secret factions to
                historical events — every element of your world, organized and
                cross-referenced with the characters and scenes that bring it to
                life.
              </p>
              <ul className="space-y-3 mb-8" role="list" data-id="element-785">
                <li className="flex items-start gap-3" data-id="element-786">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-787" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-788">
                    Rules and systems (magic, laws, physics)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-789">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-790" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-791">
                    Objects, MacGuffins, and artifacts
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-792">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-793" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-794">
                    Factions, organizations, and families
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-795">
                  <CheckIcon className="w-5 h-5 text-amber mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-796" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-797">
                    Terminology, slang, and invented language
                  </span>
                </li>
              </ul>
              <Link to="/features" className="font-sans text-sm font-medium text-amber hover:text-amber-dark flex items-center gap-2 transition-colors" data-id="element-798">
                Explore world-building tools
                <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-799" />
              </Link>
            </div>
            <div className="bg-parchment rounded-2xl p-8 border border-parchment/80" data-id="element-800">
              <div className="bg-white rounded-xl shadow-sm border border-parchment overflow-hidden" data-id="element-801">
                <div className="bg-navy px-4 py-3" data-id="element-802">
                  <span className="font-sans text-xs text-white/50" data-id="element-803">
                    World-Building · The Long Road
                  </span>
                </div>
                <div className="p-5" data-id="element-804">
                  <div className="grid grid-cols-2 gap-3" data-id="element-805">
                    <div className="bg-cream rounded-lg p-3 border border-parchment" data-id="element-806">
                      <div className="font-sans text-xs text-ink-light uppercase tracking-wide mb-2" data-id="element-807">
                        Rules
                      </div>
                      <div className="font-sans text-sm font-medium text-ink" data-id="element-808">
                        3 entries
                      </div>
                      <div className="font-sans text-xs text-ink-light mt-1" data-id="element-809">
                        The Accord, Memory Law...
                      </div>
                    </div>
                    <div className="bg-cream rounded-lg p-3 border border-parchment" data-id="element-810">
                      <div className="font-sans text-xs text-ink-light uppercase tracking-wide mb-2" data-id="element-811">
                        Factions
                      </div>
                      <div className="font-sans text-sm font-medium text-ink" data-id="element-812">
                        5 entries
                      </div>
                      <div className="font-sans text-xs text-ink-light mt-1" data-id="element-813">
                        The Council, Remnants...
                      </div>
                    </div>
                    <div className="bg-cream rounded-lg p-3 border border-parchment" data-id="element-814">
                      <div className="font-sans text-xs text-ink-light uppercase tracking-wide mb-2" data-id="element-815">
                        Objects
                      </div>
                      <div className="font-sans text-sm font-medium text-ink" data-id="element-816">
                        8 entries
                      </div>
                      <div className="font-sans text-xs text-ink-light mt-1" data-id="element-817">
                        The Ledger, Red Coat...
                      </div>
                    </div>
                    <div className="bg-cream rounded-lg p-3 border border-parchment" data-id="element-818">
                      <div className="font-sans text-xs text-ink-light uppercase tracking-wide mb-2" data-id="element-819">
                        Terminology
                      </div>
                      <div className="font-sans text-sm font-medium text-ink" data-id="element-820">
                        12 entries
                      </div>
                      <div className="font-sans text-xs text-ink-light mt-1" data-id="element-821">
                        Greywalker, The Fade...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section E: Pricing Preview */}
      <section className="bg-parchment py-24 px-6 lg:px-8" aria-labelledby="pricing-preview-heading" data-id="element-822">
        <div className="max-w-7xl mx-auto" data-id="element-823">
          <div className="text-center mb-16" data-id="element-824">
            <h2 id="pricing-preview-heading" className="font-serif text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-825">
              Start free. Upgrade when you're ready.
            </h2>
            <p className="font-sans text-base text-ink-muted" data-id="element-826">
              No tricks, no pressure. The free plan is genuinely free, forever.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-827">
            {/* Free */}
            <div className="bg-white rounded-2xl p-8 border border-parchment shadow-sm" data-id="element-828">
              <div className="mb-6" data-id="element-829">
                <h3 className="font-serif text-xl font-semibold text-ink mb-1" data-id="element-830">
                  Free
                </h3>
                <div className="flex items-baseline gap-1 mb-2" data-id="element-831">
                  <span className="font-serif text-4xl font-bold text-ink" data-id="element-832">
                    $0
                  </span>
                  <span className="font-sans text-sm text-ink-light" data-id="element-833">
                    /month
                  </span>
                </div>
                <p className="font-sans text-sm text-ink-muted" data-id="element-834">
                  For writers just getting started
                </p>
              </div>
              <ul className="space-y-2.5 mb-8" role="list" data-id="element-835">
                <li className="flex items-center gap-2.5" data-id="element-836">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-837" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-838">
                    1 project
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-839">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-840" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-841">
                    10 characters
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-842">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-843" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-844">
                    20 scenes
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-845">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-846" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-847">
                    Community support
                  </span>
                </li>
              </ul>
              <Link to="/waitlist" className="block w-full text-center font-sans text-sm font-medium border border-ink/20 text-ink hover:bg-parchment py-3 rounded-full transition-colors" data-id="element-848">
                Get Started Free
              </Link>
            </div>

            {/* Pro */}
            <div className="bg-navy rounded-2xl p-8 border border-navy shadow-sm relative" data-id="element-849">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-850">
                <span className="bg-amber text-white font-sans text-xs font-semibold px-4 py-1 rounded-full" data-id="element-851">
                  Most Popular
                </span>
              </div>
              <div className="mb-6" data-id="element-852">
                <h3 className="font-serif text-xl font-semibold text-white mb-1" data-id="element-853">
                  Pro
                </h3>
                <div className="flex items-baseline gap-1 mb-2" data-id="element-854">
                  <span className="font-serif text-4xl font-bold text-white" data-id="element-855">
                    $12
                  </span>
                  <span className="font-sans text-sm text-white/50" data-id="element-856">
                    /month
                  </span>
                </div>
                <p className="font-sans text-sm text-white/60" data-id="element-857">
                  Billed annually · $15/mo monthly
                </p>
              </div>
              <ul className="space-y-2.5 mb-8" role="list" data-id="element-858">
                <li className="flex items-center gap-2.5" data-id="element-859">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-860" />
                  <span className="font-sans text-sm text-white/80" data-id="element-861">
                    Unlimited projects
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-862">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-863" />
                  <span className="font-sans text-sm text-white/80" data-id="element-864">
                    Unlimited characters & scenes
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-865">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-866" />
                  <span className="font-sans text-sm text-white/80" data-id="element-867">
                    AI features
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-868">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-869" />
                  <span className="font-sans text-sm text-white/80" data-id="element-870">
                    PDF & Fountain export
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-871">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-872" />
                  <span className="font-sans text-sm text-white/80" data-id="element-873">
                    Priority support
                  </span>
                </li>
              </ul>
              <Link to="/waitlist" className="block w-full text-center font-sans text-sm font-medium bg-amber hover:bg-amber-dark text-white py-3 rounded-full transition-colors" data-id="element-874">
                Start Free Trial
              </Link>
            </div>

            {/* Team */}
            <div className="bg-white rounded-2xl p-8 border border-parchment shadow-sm" data-id="element-875">
              <div className="mb-6" data-id="element-876">
                <h3 className="font-serif text-xl font-semibold text-ink mb-1" data-id="element-877">
                  Team
                </h3>
                <div className="flex items-baseline gap-1 mb-2" data-id="element-878">
                  <span className="font-serif text-4xl font-bold text-ink" data-id="element-879">
                    $29
                  </span>
                  <span className="font-sans text-sm text-ink-light" data-id="element-880">
                    /seat/mo
                  </span>
                </div>
                <p className="font-sans text-sm text-ink-muted" data-id="element-881">
                  For writing rooms and collaborators
                </p>
              </div>
              <ul className="space-y-2.5 mb-8" role="list" data-id="element-882">
                <li className="flex items-center gap-2.5" data-id="element-883">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-884" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-885">
                    Everything in Pro
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-886">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-887" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-888">
                    Real-time collaboration
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-889">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-890" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-891">
                    Feedback & @mentions
                  </span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-892">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-893" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-894">SSO</span>
                </li>
                <li className="flex items-center gap-2.5" data-id="element-895">
                  <CheckIcon className="w-4 h-4 text-amber flex-shrink-0" aria-hidden="true" data-id="element-896" />
                  <span className="font-sans text-sm text-ink-muted" data-id="element-897">
                    Dedicated support
                  </span>
                </li>
              </ul>
              <a href="#" className="block w-full text-center font-sans text-sm font-medium border border-ink/20 text-ink hover:bg-parchment py-3 rounded-full transition-colors" data-id="element-898">
                Contact Sales
              </a>
            </div>
          </div>

          <div className="text-center mt-8" data-id="element-899">
            <Link to="/pricing" className="font-sans text-sm text-ink-muted hover:text-ink flex items-center gap-2 justify-center transition-colors" data-id="element-900">
              See full pricing details
              <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-901" />
            </Link>
          </div>
        </div>
      </section>

      {/* Section F: Final CTA */}
      <section className="bg-cream py-24 px-6 lg:px-8" aria-labelledby="final-cta-heading" data-id="element-902">
        <div className="max-w-3xl mx-auto text-center" data-id="element-903">
          <h2 id="final-cta-heading" className="font-serif text-4xl md:text-5xl font-bold text-ink mb-6 leading-tight" data-id="element-904">
            Your story deserves better than a spreadsheet.
          </h2>
          <p className="font-sans text-lg text-ink-muted leading-relaxed mb-10 max-w-xl mx-auto" data-id="element-905">
            Join writers who've stopped managing their story across seventeen
            different places. Start building your story bible today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-906">
            <Link to="/waitlist" className="font-sans font-medium text-base bg-amber hover:bg-amber-dark text-white px-10 py-4 rounded-full transition-colors shadow-md" data-id="element-907">
              Join the Waitlist
            </Link>
            <Link to="/features" className="font-sans font-medium text-base text-ink-muted hover:text-ink px-10 py-4 rounded-full border border-parchment hover:border-ink-light transition-colors" data-id="element-908">
              Explore Features
            </Link>
          </div>
          <p className="font-sans text-xs text-ink-light mt-6" data-id="element-909">
            ✦ Free forever plan &nbsp;·&nbsp; No credit card required
            &nbsp;·&nbsp; Cancel anytime
          </p>
        </div>
      </section>
    </main>;
}